module.exports = __webpack_public_path__ + "static/img/left-bottom-corner.2d75aa0f.png";